<div class="terminal-button-container">
    <div>
        {{ titleKey | translate }}
    </div>

    <div class="terminal-options-container">
        <div
            class="terminal-button selected"
            [class.disable]="disabled"
            (click)="onClick(option, TerminalDirection.LEFT)">
            {{ '+' + ('system-settings.do-slot.terminal.left' | translate: { num: terminalCount }) }}
        </div>

        <div
            class="terminal-button selected"
            [class.disable]="disabled"
            (click)="onClick(option, TerminalDirection.RIGHT)">
            {{ '+' + ('system-settings.do-slot.terminal.right' | translate: { num: terminalCount }) }}
        </div>
    </div>
</div>
